import { useState } from "react";
import { Download, Loader2, Play } from "lucide-react";
import { api } from "../lib/api";
import { apiError } from "../lib/auth";

export const VideoEvidence = ({ vid, testid = `video-evidence-${vid}`, compact = false }) => {
  const [url, setUrl] = useState(null);
  const [type, setType] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const load = async () => {
    setBusy(true); setErr("");
    try { const r = await api.get(`/verifications/${vid}/video`, { responseType: "blob" }); setType(r.data.type); setUrl(URL.createObjectURL(r.data)); }
    catch (e) { setErr(e.response?.status === 404 ? "This video was deleted or isn't available." : apiError(e)); }
    finally { setBusy(false); }
  };
  const ext = type.includes("mp4") ? "mp4" : type.includes("quicktime") ? "mov" : "webm";
  return (
    <div className={compact ? "" : "mt-2"} data-testid={testid}>
      {!url && <button onClick={load} disabled={busy} className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wider text-brand hover:underline disabled:opacity-50" data-testid={`${testid}-play`}>
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Play className="w-3 h-3" />}{busy ? "loading video…" : "play video"}</button>}
      {err && <p className="text-xs text-red-300 mt-1" data-testid={`${testid}-error`}>{err}</p>}
      {url && (
        <div className="mt-2">
          <video src={url} controls autoPlay playsInline className="w-full max-w-sm rounded bg-black" data-testid={`${testid}-player`}
            onError={() => setErr("Your browser can't play this format. Download it and open it in Chrome or VLC.")} />
          <a href={url} download={`verification-${vid}.${ext}`} className="inline-flex items-center gap-1.5 mt-1 font-mono text-[10px] text-white/60 hover:text-white" data-testid={`${testid}-download`}><Download className="w-3 h-3" />download original</a>
        </div>
      )}
    </div>
  );
};
